import React from 'react';

export const AIChatIcon = (props) => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 13.2974V9.4976C17.5 8.94531 17.9477 8.4976 18.5 8.4976C19.0523 8.4976 19.5 8.94531 19.5 9.4976V13.2974C19.5 16.3353 17.0666 18.8978 13.9004 18.898H7.45801L3.73633 21.9693C3.72452 21.979 3.71244 21.9884 3.7002 21.9976C3.22285 22.3556 2.59136 22.4391 2.04883 22.2017C1.46549 21.9464 1.09968 21.3732 1.09961 20.6978V17.6177C0.384746 16.8366 4.55016e-05 15.7985 0 14.6978V9.19779C0 6.04551 2.54791 3.4976 5.7002 3.4976H13.5C14.0523 3.4976 14.5 3.94532 14.5 4.4976C14.5 5.04989 14.0523 5.4976 13.5 5.4976H5.7002C3.65248 5.4976 2 7.15008 2 9.19779V14.6978C2.00005 15.429 2.28977 16.0427 2.75098 16.438C2.97262 16.628 3.09961 16.9059 3.09961 17.1978V19.9009L6.46387 17.1265L6.60645 17.0279C6.75596 16.943 6.92575 16.8981 7.09961 16.898H13.9004C15.9338 16.8978 17.5 15.2592 17.5 13.2974Z"
      fill="white"
    />
    <path
      d="M5.7998 10.5166V8.91703C5.7998 8.36475 6.24752 7.91703 6.7998 7.91703C7.35209 7.91703 7.7998 8.36475 7.7998 8.91703V10.5166C7.7998 11.0689 7.35209 11.5166 6.7998 11.5166C6.24752 11.5166 5.7998 11.0689 5.7998 10.5166ZM11 10.5166V8.91703C11 8.36475 11.4477 7.91703 12 7.91703C12.5522 7.91714 13 8.36481 13 8.91703V10.5166C13 11.0689 12.5522 11.5165 12 11.5166C11.4477 11.5166 11 11.0689 11 10.5166Z"
      fill="white"
    />
    <path
      d="M11.298 13.0439C11.6885 12.6534 12.2215 12.6534 12.612 13.0439C13.0024 13.4344 13.0024 13.9394 12.612 14.3299C11.732 15.2099 10.4779 15.5975 9.30439 15.5975C8.13102 15.5974 6.87762 15.2098 5.99775 14.3299C5.60722 13.9394 5.60722 13.4344 5.99775 13.0439C6.38827 12.6533 6.90376 12.6533 7.29428 13.0439C7.71424 13.4638 8.52803 13.7875 9.30439 13.7876C10.0809 13.7876 10.878 13.4639 11.298 13.0439Z"
      fill="white"
    />
    <path
      d="M18.4004 0.8975C18.8004 2.4975 19.8004 3.4975 21.4004 3.8975C19.8004 4.2975 18.8004 5.2975 18.4004 6.8975C18.0004 5.2975 17.0004 4.2975 15.4004 3.8975C17.0004 3.4975 18.0004 2.4975 18.4004 0.8975Z"
      fill="white"
    />
    <path
      d="M21.7423 7.64767C21.9089 8.34767 22.3423 8.78101 23.0423 8.94767C22.3423 9.11434 21.9089 9.54767 21.7423 10.2477C21.5756 9.54767 21.1423 9.11434 20.4423 8.94767C21.1423 8.78101 21.5756 8.34767 21.7423 7.64767Z"
      fill="white"
    />
    <path
      d="M13.9004 0C14.0671 0.7 14.5004 1.13333 15.2004 1.3C14.5004 1.46667 14.0671 1.9 13.9004 2.6C13.7337 1.9 13.3004 1.46667 12.6004 1.3C13.3004 1.13333 13.7337 0.7 13.9004 0Z"
      fill="white"
    />
  </svg>
);
